<template>
	<div class="table-view-tab display-flex flex-column height-100">
		<div class="flex-space-between--center">
			<div class="table-title">{{ tableTitle }}</div>
			<div class="search-field"><AppSearch :searchString.sync="searchString" /></div>
		</div>

		<TableView class="flex-1" :headers="columnDefsFromPreviousSteps" :rows="filteredRowsFromPreviousSteps" :gridOptions="gridOptions" />
	</div>
</template>

<script>
import TableView from '@/components/common/TableView/TableView';
export default {
	name: 'TableViewTab',
	components: {
		TableView,
	},
	props: {
		drawerContent: { type: Object },
		titleKey: { type: String },
	},
	computed: {
		tabData() {
			return this.drawerContent.tableViewer[this.titleKey];
		},
		tableTitle() {
			return this.tabData.tableSourceName;
		},
		rowsFromPreviousSteps() {
			return this.tabData.rowsFromPreviousSteps;
		},
		filteredRowsFromPreviousSteps() {
			const strToSearch = this.searchString.toLowerCase();
			if (strToSearch) {
				return this.tabData.rowsFromPreviousSteps.filter((row) => {
					const rowIncludesSearchString = (result, columnVal) => result || columnVal.toString().toLowerCase().includes(strToSearch);
					return Object.values(row).reduce(rowIncludesSearchString, false);
				});
			}
			return this.tabData.rowsFromPreviousSteps;
		},
		columnDefsFromPreviousSteps() {
			return this.tabData.columnDefsFromPreviousSteps.map((cDef) => ({ ...cDef, minWidth: 100 }));
		},
	},
	data: () => ({
		searchString: '',
		gridOptions: {
			suppressFieldDotNotation: true,
			defaultColDef: {
				resizable: true,
				valueFormatter: ({ value }) => {
					if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
						return JSON.stringify(value);
					}
					return value;
				},
			},
		},
	}),
};
</script>

<style scoped lang="scss"></style>
